import React from "react";
import {
  Breakpoint,
  ElementViewProps,
  IconShape,
  SocialLinkName,
  SocialLinksSettings,
} from "@/shared/types";
import * as SocialLinksIcons from "./icons";

export interface SocialLinksViewProps extends ElementViewProps {
  noAction?: boolean;
}

const SocialLinksView: React.FC<SocialLinksViewProps> = ({
  element,
  breakpoint,
  wuiltContext,
  noAction,
}) => {
  const values = element?.settings as SocialLinksSettings;
  const Link = wuiltContext?.base?.Link;
  const size = values?.iconStyle?.size;
  const horizontalAlignment =
    element?.layout[breakpoint ?? Breakpoint.Desktop]?.alignment?.horizontal;

  const SocialLinks: any = {
    [SocialLinkName.Behance]: {
      [IconShape.Filled]: <SocialLinksIcons.BehanceFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.BehanceOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.BehanceColored size={size} />,
    },
    [SocialLinkName.Discord]: {
      [IconShape.Filled]: <SocialLinksIcons.DiscordFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.DiscordOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.DiscordColored size={size} />,
    },
    [SocialLinkName.Dribbble]: {
      [IconShape.Filled]: <SocialLinksIcons.DribbbleFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.DribbbleOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.DribbbleColored size={size} />,
    },
    [SocialLinkName.Facebook]: {
      [IconShape.Filled]: <SocialLinksIcons.FacebookFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.FacebookOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.FacebookColored size={size} />,
    },
    [SocialLinkName.Messenger]: {
      [IconShape.Filled]: (
        <SocialLinksIcons.FacebookMessengerFilled size={size} />
      ),
      [IconShape.Outlined]: (
        <SocialLinksIcons.FacebookMessengerOutlined size={size} />
      ),
      [IconShape.Colored]: (
        <SocialLinksIcons.FacebookMessengerColored size={size} />
      ),
    },
    [SocialLinkName.Github]: {
      [IconShape.Filled]: <SocialLinksIcons.GithubFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.GithubOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.GithubColored size={size} />,
    },
    [SocialLinkName.Instagram]: {
      [IconShape.Filled]: <SocialLinksIcons.InstagramFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.InstagramOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.InstagramColored size={size} />,
    },
    [SocialLinkName.Linkedin]: {
      [IconShape.Filled]: <SocialLinksIcons.LinkedinFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.LinkedinOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.LinkedinColored size={size} />,
    },
    [SocialLinkName.Pinterest]: {
      [IconShape.Filled]: <SocialLinksIcons.PinterestFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.PinterestOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.PinterestColored size={size} />,
    },
    [SocialLinkName.Skype]: {
      [IconShape.Filled]: <SocialLinksIcons.SkypeFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.SkypeOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.SkypeColored size={size} />,
    },
    [SocialLinkName.Telegram]: {
      [IconShape.Filled]: <SocialLinksIcons.TelegramFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.TelegramOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.TelegramAppColored size={size} />,
    },
    [SocialLinkName.Tiktok]: {
      [IconShape.Filled]: <SocialLinksIcons.TiktokFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.TiktokOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.TiktokColored size={size} />,
    },
    [SocialLinkName.Twitter]: {
      [IconShape.Filled]: <SocialLinksIcons.TwitterFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.TwitterOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.TwitterColored size={size} />,
    },
    [SocialLinkName.Whatsapp]: {
      [IconShape.Filled]: <SocialLinksIcons.WhatsappFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.WhatsappOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.WhatsappColored size={size} />,
    },
    [SocialLinkName.Youtube]: {
      [IconShape.Filled]: <SocialLinksIcons.YoutubeFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.YoutubeOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.YoutubeColored size={size} />,
    },
    [SocialLinkName.Snapchat]: {
      [IconShape.Filled]: <SocialLinksIcons.SnapchatFilled size={size} />,
      [IconShape.Outlined]: <SocialLinksIcons.SnapchatOutlined size={size} />,
      [IconShape.Colored]: <SocialLinksIcons.SnapchatColored size={size} />,
    },
  };

  return (
    <div
      style={{
        width: "fit-content",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: horizontalAlignment ?? "start",
      }}
    >
      {values?.socialLinks?.map((button, index) => (
        <Link
          key={index}
          href={noAction ? undefined : button?.link}
          target={noAction ? undefined : "_blank"}
          style={{
            marginInlineEnd: "15px",
            color: values?.iconStyle?.color?.value,
          }}
        >
          {SocialLinks?.[button?.name!]?.[values?.iconStyle?.shape!]}
        </Link>
      ))}
    </div>
  );
};

export { SocialLinksView };
